import BundleProductConfigurationsIdentifier from "../constants/BundleProductConfigurationsIdentifier";
import { IBundleProductConfiguration } from "../entities/manhattan/bundle/types";
import Validator from "../validators/Validator";

export default class BundleProductConfigurationService {

  private static instance: BundleProductConfigurationService;
  private bundleProductConfigurations: IBundleProductConfiguration[];

  public static getInstance(): BundleProductConfigurationService {
    if (!this.instance) {
      this.instance = new BundleProductConfigurationService();
    }

    return this.instance;
  }

  public setBundleProductConfigurations(bundleProductConfigurations: IBundleProductConfiguration[]) {
    this.bundleProductConfigurations = bundleProductConfigurations;
  }

  public getNumberOfAdditionalDevicesFromConfiguration() {
    return this.getMaximumDevicesFromConfiugarition() - this.getMinimumDevicesFromConfiguration();
  }

  public getMinimumDevicesFromConfiguration() : number {
    return this.getDevices(BundleProductConfigurationsIdentifier.MINIMUM_NUMBER_OF_ITEMS);
  }

  public getMaximumDevicesFromConfiugarition() : number {
    return this.getDevices(BundleProductConfigurationsIdentifier.MAXIMUM_NUMBER_OF_ITEMS);
  }

  private getDevices(identifier: string) : number {
    const allowedAdditionalDevices = this.bundleProductConfigurations.find(
      (bundleProductConfiguration: IBundleProductConfiguration) =>
        bundleProductConfiguration.configuration.identifier === identifier
    );

    if (typeof allowedAdditionalDevices !== 'undefined' &&
      Validator.isObject(allowedAdditionalDevices)
    ) {
      return Number(allowedAdditionalDevices.value);
    }

    return 0;
  }


}
